import Plan from '@/page/promotion/promotionTool/Plan'
import Member from '@/page/promotion/promotionTool/Member'
import TimedSpecials from '@/page/promotion/promotionTool/TimedSpecials'
import TilimitDiscount from '@/page/promotion/promotionTool/TilimitDiscount'
import FullReduction from '@/page/promotion/promotionTool/FullReduction'
import FullDiscount from '@/page/promotion/promotionTool/FullDiscount'
import activityStatistics from '@/page/activity/statistics'
import activityDetail from '@/page/activity/detail'
export const promotion=[
    {
        path: '/promotion/plan',
        name: 'plan',
        component: Plan,
        meta: {
          requireAuth: true,
          title: '促销活动'
        }
    },
    {
      path: '/promotion/member',
      name: 'plan',
      component: Member,
      meta: {
        requireAuth: true,
        title: '会员营销'
      }
    },
    {
      path: '/promotion/timedSpecials',
      name: 'timedSpecials',
      component: TimedSpecials,
      meta: {
        requireAuth: true,
        title: '限时特价'
      }
    },
    {
      path: '/promotion/tilimitDiscount',
      name: 'tilimitDiscount',
      component: TilimitDiscount,
      meta: {
        requireAuth: true,
        title: '限时折扣'
      }
    },
    {
      path: '/promotion/fullReduction',
      name: 'fullReduction',
      component: FullReduction,
      meta: {
        requireAuth: true,
        title: '满减活动'
      }
    },
    {
      path: '/promotion/fullDiscount',
      name: 'fullDiscount',
      component: FullDiscount,
      meta: {
        requireAuth: true,
        title: '满减折扣'
      }
    },
  {
    path: '/activity/statistics',
    name: '营销统计',
    component: activityStatistics,
    meta: {
      requireAuth: true,
      title: '营销统计'
    }
  },
  {
    path: '/activity/detail',
    name: '活动统计详情',
    component: activityDetail,
    meta: {
      requireAuth: true,
      title: '活动统计详情'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/promotion.route.js